import axios from 'axios'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'

import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { EntityIdentifiersRequest, EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'
import { ConfigurationLocalAccountingBillableCustomerBillableRateCreateRequest, ConfigurationLocalAccountingBillableCustomerBillableRatePatchInBatchRequest, ConfigurationLocalAccountingBillableCustomerBillableRateResponse } from '@/modules/configurationModule/detail/local-accounting/billable/clients/services/customer-billable-rates-services/configuration-local-accounting-billable-clients-rates.dto'

class ConfigurationLocalAccountingBillableCustomerRatesService {
    async create(laboratoryId: number, request: ConfigurationLocalAccountingBillableCustomerBillableRateCreateRequest): Promise<ConfigurationLocalAccountingBillableCustomerBillableRateResponse> {
        const response = await axios.post<ConfigurationLocalAccountingBillableCustomerBillableRateResponse>(
            `/configuration/laboratories/${laboratoryId}/customerBillableRates`,
            request
        )
        return response.data
    }

    async paginator(filterModel: CommonFilterModel | undefined, params: CommonParams | undefined, laboratoryId: number): Promise<IResponseAgGrid<ConfigurationLocalAccountingBillableCustomerBillableRateResponse>> {
        const response = await axios.put<IResponseAgGrid<ConfigurationLocalAccountingBillableCustomerBillableRateResponse>>(
            `/configuration/laboratories/${laboratoryId}/customerBillableRates`,
            { ...filterModel },
            { params }
        )
        return response.data
    }

    async get(laboratoryId: number, billableRateBillableConceptId : number): Promise<ConfigurationLocalAccountingBillableCustomerBillableRateResponse> {
        const response = await axios.get<ConfigurationLocalAccountingBillableCustomerBillableRateResponse>(
            `/configuration/laboratories/${laboratoryId}/customerBillableRates/${billableRateBillableConceptId}`
        )
        return response.data
    }

    async delete(laboratoryId: number, request: EntityIdentifiersRequest): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.delete<EntityIdentifierWithErrorResponse[]>(
            `/configuration/laboratories/${laboratoryId}/customerBillableRates/batch`, { data: request }
        )
        return response.data
    }

    async patch(laboratoryId: number, request: ConfigurationLocalAccountingBillableCustomerBillableRatePatchInBatchRequest[]): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.patch<EntityIdentifierWithErrorResponse[]>(
            `/configuration/laboratories/${laboratoryId}/customerBillableRates/batch`,
            request
        )
        return response.data
    }
}

export const configurationLocalAccountingBillableCustomerRatesService = new ConfigurationLocalAccountingBillableCustomerRatesService()
